"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M7.919 21C16.22 21 20.76 14.074 20.76 8.068c0-.196 0-.392-.013-.587A9.218 9.218 0 0023 5.128a8.961 8.961 0 01-2.593.715 4.555 4.555 0 001.985-2.513 9.007 9.007 0 01-2.866 1.103 4.495 4.495 0 00-5.423-.895 4.56 4.56 0 00-2.27 5.04 12.785 12.785 0 01-9.302-4.749A4.567 4.567 0 003.93 9.896a4.457 4.457 0 01-2.049-.568v.057a4.539 4.539 0 003.621 4.455 4.476 4.476 0 01-2.038.078 4.523 4.523 0 004.217 3.157A9.017 9.017 0 011 18.958a12.715 12.715 0 006.919 2.039" }), "Twitter");
//# sourceMappingURL=Twitter.js.map